import { lazy, Suspense, useState, useCallback, useMemo } from 'react';
import { CUSTOM_MESSAGES } from '@veriables';
import {
  useSubmitTableNumber,
  useValidateTableNumber,
  useGoToOrderFromSearch,
  useSubmitTabName,
} from '../header/headerHandler';

const OpenTableCheckModal = lazy(() =>
  import('@components/storeChecks/Modals/OpenTableCheck')
);
const AddTableModalComponent = lazy(() =>
  import('@components/storeChecks/Modals/AddTableModal')
);
const ExistingCheckModal = lazy(() =>
  import('@containers/StoreChecks/Modals/ExistingCheckModal')
);
const NewCheckModalAnyEmployee = lazy(() =>
  import('@containers/StoreChecks/Modals/NewCheckModalAnyEmployee')
)

export const useTableModal = ({
  serverAppTheme,
  orderingPortraitOrientation,
  deviceGroup,
  tableData,
  pageNo,
  deviceInfo,
  setErrorPopUp,
  employeeHashTable,
  userInfo,
}) => {
  const [isOpenCheck, setIsOpenCheck] = useState(false);
  const [showTableSearchField, setShowTableSearchField] = useState(false);
  const [checkModelOpen, setCheckModelOpen] = useState(false);
  const [tableValue, setTableValue] = useState(null);

  const onOpenTable = useCallback(() => setIsOpenCheck(true), []);
  const [newCheckModalAnyEmployee, setNewCheckModalAnyEmployee] = useState({
    isOpen: false,
  });
  const onCloseTable = useCallback(() => {
    setIsOpenCheck(false);
    setShowTableSearchField(false);
  }, []);
  const onTableOpen = useCallback(data => {
    setIsOpenCheck(false);
    setShowTableSearchField(false);
    setTableValue(data);
    setCheckModelOpen(true);
  }, []);
  
  const order = useGoToOrderFromSearch();
  const handleGoToOrder = useCallback((isCheck) => {
    setIsOpenCheck(false);
    setShowTableSearchField(false);
    order(isCheck);
  }, [order]);

  const handleShowConflictModal = useCallback((data, employeData) => {
    setIsOpenCheck(false);
    setShowTableSearchField(false);
    setTableValue(data);
    setNewCheckModalAnyEmployee({
      isOpen: true,
      employeeName: employeData?.firstName,
      lastName: employeData?.lastName,
      externalId: employeData?.externalId,
    });
  }, []);

  const submitTableNumber = useSubmitTableNumber();
  const validateTableNumber = useValidateTableNumber({
    onTableOpen,
    onGoToOrder: handleGoToOrder,
    onShowConflictModal: handleShowConflictModal,
  });

  const tableDataArray = useMemo(
    () => (tableData ? Object.values(tableData) : []),
    [tableData]
  );

  const submitTabName = useSubmitTabName();
  const handleNewCheck = useCallback(() => {
    tableValue?.tabName !== undefined && tableValue?.tabName !== null
      ? submitTabName(tableValue)
      : submitTableNumber(tableValue);
  }, [tableValue, submitTableNumber, submitTabName]);

  const jsx = (
    <>
      {isOpenCheck && (
        <Suspense fallback={null}>
          <OpenTableCheckModal
            serverAppTheme={serverAppTheme}
            isOpenCheck={isOpenCheck}
            onCloseTable={onCloseTable}
          >
            <AddTableModalComponent
              name="tableNumber"
              placeholder={CUSTOM_MESSAGES().ENTER_TABLE_NUMBER}
              validate={validateTableNumber}
              onSubmit={submitTableNumber}
              orderingPortraitOrientation={orderingPortraitOrientation}
              deviceGroup={deviceGroup}
              serverAppTheme={serverAppTheme}
              searchData={tableDataArray}
              order={order}
              showTableSearchField={showTableSearchField}
              setShowTableSearchField={setShowTableSearchField}
              onCloseTable={onCloseTable}
              setErrorPopUp={setErrorPopUp}
            />
          </OpenTableCheckModal>
        </Suspense>
      )}

      {checkModelOpen && (
        <Suspense fallback={null}>
          <ExistingCheckModal
            checkModelOpen={checkModelOpen}
            setCheckModelOpen={setCheckModelOpen}
            isTableValue={tableValue}
            serverAppTheme={serverAppTheme}
            setIsOpenCheck={setIsOpenCheck}
            setIsModalOpen={() => { }}
            submitTableNumber={submitTableNumber}
            goToOrder={order}
            tableData={tableData}
            pageNo={pageNo}
            deviceInfo={deviceInfo}
          />
        </Suspense>
      )}
      <Suspense fallback={null}>
        {newCheckModalAnyEmployee?.isOpen && (
          <NewCheckModalAnyEmployee
            checkModelOpen={newCheckModalAnyEmployee?.isOpen}
            serverAppTheme={serverAppTheme}
            setNewCheckModalAnyEmployee={setNewCheckModalAnyEmployee}
            newCheckModalAnyEmployee={newCheckModalAnyEmployee}
            setIsOpenCheck={setIsOpenCheck}
            handleNewCheck={handleNewCheck}
            setCheckModelOpen={setCheckModelOpen}
            deviceInfo={deviceInfo}
          />
        )}
      </Suspense>
    </>
  );

  return { onOpenTable, jsx };
};
